module.exports = __webpack_public_path__ + "img/menu_event.22fa1882.svg";